import { BrowserRouter, Routes, Route } from "react-router-dom";
import AdminLogin from "../screens/auth/AdminLogin";
import Categories from "../screens/dashboard/Categories";
import CreateCategory from "../screens/dashboard/CreateCategory";
import Products from "../screens/dashboard/Products";
import UpdateCategory from "../screens/dashboard/UpdateCategory";
import CreateProduct from "../screens/dashboard/CreateProduct";
import Private from "./Private.js";
import Public from "./Public";
import EditProduct from "../screens/dashboard/EditProduct";
import Home from "../screens/home/Home";
import Login from "../screens/home/auth/Login";
import Register from "../screens/home/auth/Register";
import Dashboard from "../screens/users/Dashboard";
import UserRoute from "./UserRoute";
import UserAuthRoute from "./UserAuthRoute";
import CatProducts from "../screens/home/CatProducts";
import Product from "../screens/home/Product";
import SearchProducts from "../screens/home/SearchProducts";
import Cart from "../screens/home/Cart";
import Orders from "../screens/dashboard/Orders";
import OrderDetails from "../screens/dashboard/OrderDetails";
import UserOrders from "../screens/users/UserOrders";
import UserOrderDetails from "../screens/users/UserOrderDetails";
import UserAddresses from "../screens/users/UserAddresses";
import UserSettings from "../screens/users/UserSettings";
import UserWishlist from "../screens/users/UserWishlist";
import UserSupport from "../screens/users/UserSupport";
import UserReturns from "../screens/users/UserReturns";
import Checkout from "../screens/home/Checkout";
import OrderSuccess from "../screens/home/OrderSuccess";
import PaymentResult from "../screens/home/PaymentResult";
import SizeFinder from "../screens/home/SizeFinder";
import AllProducts from "../screens/home/AllProducts";
import StaticPage from "../screens/home/StaticPage";
import ErrorPage from "../screens/home/ErrorPage";
import ScrollToTop from "../components/home/ScrollToTop";
import BackToTopButton from "../components/home/BackToTopButton";
import AnalyticsTracker from "../components/home/AnalyticsTracker";
import AuthSessionSync from "../components/auth/AuthSessionSync";
const Routing = () => {
  return (
    <BrowserRouter>
      <AuthSessionSync />
      <ScrollToTop />
      <AnalyticsTracker />
      <BackToTopButton />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="size-finder" element={<SizeFinder />} />
        <Route path="products" element={<AllProducts />} />
        <Route path="products/:page" element={<AllProducts />} />
        <Route path="category/:name" element={<CatProducts />} />
        <Route path="category/:name/:page" element={<CatProducts />} />
        <Route path="cat-products/:name" element={<CatProducts />} />
        <Route path="cat-products/:name/:page" element={<CatProducts />} />
        <Route
          path="search-products/:keyword/:page"
          element={<SearchProducts />}
        />
        <Route path="cart" element={<Cart />} />
        <Route path="checkout" element={<Checkout />} />
        <Route path="order-success/:id" element={<OrderSuccess />} />
        <Route path="payment/result" element={<PaymentResult />} />
        <Route path="about" element={<StaticPage type="about" />} />
        <Route path="contact" element={<StaticPage type="contact" />} />
        <Route path="terms" element={<StaticPage type="terms" />} />
        <Route path="privacy" element={<StaticPage type="privacy" />} />
        <Route path="shipping" element={<StaticPage type="shipping" />} />
        <Route path="return-policy" element={<StaticPage type="returns" />} />
        <Route path="order-tracking" element={<StaticPage type="order-tracking" />} />
        <Route path="500" element={<ErrorPage type="500" />} />
        <Route path="product/:id/:slug" element={<Product />} />
        <Route path="product/:name" element={<Product />} />
        <Route element={<UserAuthRoute />}>
          <Route path="login" element={<Login />} />
          <Route path="register" element={<Register />} />
        </Route>
        <Route element={<UserRoute />}>
          <Route path="user" element={<Dashboard />} />
          <Route path="user/returns" element={<UserReturns />} />
          <Route path="user/returns/:page" element={<UserReturns />} />
          <Route path="orders" element={<UserOrders />} />
          <Route path="orders/:page" element={<UserOrders />} />
          <Route path="orders/detail/:id" element={<UserOrderDetails />} />
          <Route path="user-order-details/:id" element={<UserOrderDetails />} />
          <Route path="addresses" element={<UserAddresses />} />
          <Route path="settings" element={<UserSettings />} />
          <Route path="wishlist" element={<UserWishlist />} />
          <Route path="support" element={<UserSupport />} />
        </Route>
        <Route path="auth">
          <Route
            path="admin-login"
            element={
              <Public>
                <AdminLogin />
              </Public>
            }
          />
        </Route>
        <Route path="dashboard">
          <Route
            path="products"
            element={
              <Private>
                <Products />
              </Private>
            }
          />
          <Route
            path="products/:page"
            element={
              <Private>
                <Products />
              </Private>
            }
          />
          <Route
            path="edit-product/:id"
            element={
              <Private>
                <EditProduct />
              </Private>
            }
          />
          <Route
            path="categories"
            element={
              <Private>
                <Categories />
              </Private>
            }
          />
          <Route
            path="categories/:page"
            element={
              <Private>
                <Categories />
              </Private>
            }
          />
          <Route
            path="create-category"
            element={
              <Private>
                <CreateCategory />
              </Private>
            }
          />
          <Route
            path="update-category/:id"
            element={
              <Private>
                <UpdateCategory />
              </Private>
            }
          />
          <Route
            path="create-product"
            element={
              <Private>
                <CreateProduct />
              </Private>
            }
          />
          <Route
            path="orders"
            element={
              <Private>
                <Orders />
              </Private>
            }
          />
          <Route
            path="orders/:page"
            element={
              <Private>
                <Orders />
              </Private>
            }
          />
          <Route
            path="order-details/:id"
            element={
              <Private>
                <OrderDetails />
              </Private>
            }
          />
        </Route>
        <Route path="*" element={<ErrorPage type="404" />} />
      </Routes>
    </BrowserRouter>
  );
};
export default Routing;
